import { useSearchParams } from 'react-router-dom';
import { Box, styled } from '@mui/material';
import { useEffect, useState } from 'react';

const Container = styled(Box)(() => ({
  paddingInline: 16,
  maxWidth: 600,
  margin: 'auto',

  '@supports (width: -webkit-fill-available)': {
    width: '-webkit-fill-available',
  },

  '@supports (width: -moz-available)': {
    width: '-moz-available',
  },
}));

const Main = styled(Box)(({ theme }) => ({
  overflow: 'hidden',
  width: '100%',
  borderRadius: 8,
  backgroundColor: theme.palette.border.main,
  height: 4,
}));

const Line = styled('div')<{ width: number }>(({ theme, width }) => ({
  width: `${width}%`,
  backgroundColor: 'black',
  height: '100%',
  borderRadius: 8,
  transition: 'all 0.3s ease',
}));

type Props = {
  totalSteps: number;
};

export default function ProgressiveLine({ totalSteps }: Props) {
  const [searchParams] = useSearchParams();
  const [progress, setProgress] = useState(0);
  const stepParam = Number(searchParams.get('step'));
  const stepIndex = isNaN(stepParam) ? 0 : stepParam;
  const clampedIndex = Math.min(Math.max(stepIndex, 0), totalSteps - 1);

  useEffect(() => {
    setProgress((clampedIndex / totalSteps) * 100);
  }, [clampedIndex, totalSteps]);

  if (stepIndex === 0) return null;

  return (
    <Container>
      <Main>
        <Line width={progress} />
      </Main>
    </Container>
  );
}
